export default __webpack_public_path__ + "static/O0038-8c6c98ecf874939753f436e095890e3c.png";